module.exports = __webpack_public_path__ + "img/Bitmap-Copy-14.c1767c37.png";